import { Controller } from '@hotwired/stimulus'
import $ from "jquery"
import { FetchRequest } from '@rails/request.js'
import { useDebounce } from "stimulus-use"

export default class extends Controller {
  static debounces = ['onPoChange']

  static targets = ["PoSelectInput"]

  get formBolController() {
    return document.querySelector(`[data-controller="form-bol"]`)[`form-bol`]
  }

  connect() {
    useDebounce(this, { wait: 2000 })

    $(this.PoSelectInputTarget).on("select2:select", () => {
      let event = new Event('change', { bubbles: true })
      this.PoSelectInputTarget.dispatchEvent(event)
    })
  }

  onPoChange(e) {
    let option = e.target.options[e.target.selectedIndex]
    let poId = option.dataset.poId
    let url = this.PoSelectInputTarget.dataset.lineItemsUrl
    url = url.replace(/purchase_orders\/\d+/, `purchase_orders/${poId}`)

    const request = new FetchRequest('get', url, { responseKind: 'turbo-stream' })
    request.perform()

    $("#bol_purchase_order_id").val(poId)

    this.formBolController.onPoChange(e)
  }

}